<script setup lang="ts"></script>

<template>
  <!-- guard margin-bottom -->
  <div>
    <p :class="$style.popup">オススメ</p>
  </div>
</template>

<style lang="scss" module>
/* 尻尾の線の長さ */
$arrow-size: 12px;
/* 対角線の半分 */
$arrow-height: calc(#{$arrow-size} * 0.707);

.popup {
  position: relative;
  width: fit-content;
  padding: 4px 16px;
  margin-bottom: $arrow-height;
  border-radius: 999em;
  background-color: $color-okaneko-yellow;
  font-size: 14px;
  font-weight: bold;

  &::before {
    display: block;
    position: absolute;
    top: 100%;
    left: 50%;
    z-index: -1;
    width: $arrow-size;
    height: $arrow-size;
    background-color: $color-okaneko-yellow;
    transform-origin: center;
    transform: translate(-50%, -50%) rotate(45deg);

    content: '';
  }
}
</style>
